// union is not implemented by JavaScript sets
export function union<T>(setA: Set<T>, setB: Set<T>): Set<T> {
  const set = new Set<T>(setA);
  setB.forEach(elem => {
    set.add(elem);
  });

  return set;
}
